import { useState, useEffect } from "react";
import "./CursoLanding.css";
import Loader from "../../../components/Loader/Loader";

import { useNavigate, useParams } from "react-router-dom";
import CartModal from "../CartModal";
import svgTituloCursos from "../../../assets/cursos/cursos_titulo_pagina.svg";
import ContactForm from "../../ContactForm/ContactForm";

import manoConDineroSvg from '../../../assets/cursos/icons_general/manito con dinero.svg';
import manoDerechaSvg from '../../../assets/cursos/icons_general/manito derecha del boton.svg';
import manoIzquierdaSvg from '../../../assets/cursos/icons_general/manito izquierda del boton.svg';
import NotificationModal from "../../../components/NotificationModal/NotificationModal";
import { useCartModal } from "../../../hooks/useCartModal";

function CursoLanding({ courses, user, setIsCartOpen, purchasedCourses = [], openLoginModal }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const { modalData, isAuthWarningOpen, handleBuyNow, handleContactAsesor, closeModal, closeAuthWarning } = useCartModal(user);

  const [brokenImages, setBrokenImages] = useState({});

  useEffect(() => {
    if (courses && courses.length > 0) {
      const encontrado = courses.find(c => c.slug === slug);
      setCourse(encontrado);
    }
  }, [slug, courses]);

  if (!course) {
    return <Loader texto="Cargando..." />;
  }

  const todasLasPosibles = [1, 2, 3, 4, 5, 6];
  const imagenesVisibles = todasLasPosibles.filter(num => !brokenImages[num]);
  const yaInscrito = purchasedCourses.some(comprado => comprado.id === course.id);

  const preciosActivos = [];
  if (course.precio_1_monto) preciosActivos.push({ monto: course.precio_1_monto, fecha: course.precio_1_fecha });
  if (course.precio_2_monto) preciosActivos.push({ monto: course.precio_2_monto, fecha: course.precio_2_fecha });
  if (course.precio_3_monto) preciosActivos.push({ monto: course.precio_3_monto, fecha: course.precio_3_fecha });

  const renderBotonCompra = (variante = 'centro') => {
    const textoBoton = yaInscrito ? "Ya estás inscrito" : "¡Adquiérelo ya!";
    const accion = yaInscrito ? () => navigate('/mis-cursos') : () => handleBuyNow(course);

    if (variante === 'absoluto-izquierda') {
      return (
        <div className="btn-container-abs-left">
          <img src={manoIzquierdaSvg} alt="Apuntando" className="btn-mano-icon mano-izq-anim" />
          <button onClick={accion} className="btn-compra-adquiere">{textoBoton}</button>
        </div>
      );
    }

    return (
      <div className="btn-container-center">
        <img src={manoIzquierdaSvg} alt="Apuntando" className="btn-mano-icon mano-izq-anim" />
        <button onClick={accion} className="btn-compra-adquiere">{textoBoton}</button>
        <img src={manoDerechaSvg} alt="Apuntando" className="btn-mano-icon mano-der-anim" />
      </div>
    );
  };

  return (
    <>
      <section>
        <div className="container">
          {/* 🔥 Estilos en línea pasados a la clase .curso-header-container */}
          <div className="cursos-section section-green banner-svg-container-start curso-header-container">
            <div className="svg-wrapper">
              <img src={svgTituloCursos} alt="Cursos" className="img-svg-titulo" />
            </div>
          </div>

          <div className="sublanding-dinamica section-green curso-landing-wrapper">
            
            {/* MAPEAMOS LAS IMÁGENES POSIBLES */}
            {todasLasPosibles.map((num) => {
              if (brokenImages[num]) return null;

              const indexVisual = imagenesVisibles.indexOf(num);
              const esLaPrimeraQueAparece = indexVisual === 0;
              const esLaSegundaQueAparece = indexVisual === 1;

              return (
                <div
                  key={num}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    position: esLaPrimeraQueAparece ? 'relative' : 'static',
                    width: '100%'
                  }}
                >
                  <img
                    src={`/img/cursos/${course.slug}/landing 0${num}.png`}
                    alt={`Sublanding parte ${num}`}
                    className="curso-img-block"
                    onError={() => {
                      setBrokenImages(prev => ({ ...prev, [num]: true }));
                    }}
                  />
                  {esLaPrimeraQueAparece && renderBotonCompra('absoluto-izquierda')}
                  {esLaSegundaQueAparece && renderBotonCompra('centro')}
                </div>
              );
            })}

            {/* 🔥 IMAGEN 07_1 */}
            <div className="curso-img-07-1-container">
              <img
                src={`/img/cursos/${course.slug}/landing 07_1.png`}
                alt="Detalle Precios Parte 1"
                className="curso-img-block"
              />
            </div>

            {/* 🔥 IMAGEN 07_2 */}
            <div className="curso-img-07-2-container">
              <img
                src={`/img/cursos/${course.slug}/landing 07_2.png`}
                alt="Detalle Precios Parte 2"
                className="curso-img-block"
              />

              {/* ZONA SUPERIOR: LOS RECUDROS BLANCOS DE PRECIOS */}
              <div className="curso-zona-precios">
                {preciosActivos.map((precio, idx) => (
                  <div key={idx} className="curso-precio-card">
                    <h3 className="curso-precio-monto">S/. {precio.monto}</h3>
                    <p className="description curso-precio-fecha">{precio.fecha}</p>
                  </div>
                ))}
              </div>

              {/* ZONA MEDIA: FACILIDADES DE PAGO */}
              <div className="curso-zona-pagos">
                <div className="curso-pago-border">
                  <p className="curso-pago-titulo">💰 facilidades de pago: {course.facilidades_pago || "Consulta nuestras opciones"}</p>
                </div>
                <p className="curso-pago-desc">
                  {course.nota_pago || "Se puede separar con 500 soles y pagar hasta en 3 cuotas (acordadas directamente con el asesor comercial). Se da boleta o factura (si es factura se suma el 18% de IGV)."}
                </p>
              </div>

              {/* ZONA INFERIOR: INFORMACIÓN CLAVE */}
              <div className="curso-zona-info-izq-top">
                {course.fecha_1_tipo && !course.fecha_2_tipo && (
                <p className="txt-landing">
                  100 % online en vivo  <br />
                  vía zoom
                </p>                
              )}
              </div>

              <div className="curso-zona-info-izq-bottom">
                <p className="txt-landing">{course.info_duracion} horas</p>
              </div>

              <div className="curso-zona-info-centro">
                {course.fecha_1_tipo && (
                  <div className="curso-info-margin-bottom">
                    <p className="curso-info-titulo-naranja">{course.fecha_1_tipo}</p>
                    <p className="txt-landing txt-pre-line">
                      {course.fecha_1_detalle ? course.fecha_1_detalle.replace(/\.\s+/g, '.\n') : ''}
                    </p>
                  </div>
                )}

                <div>
                  <p className="txt-landing txt-pre-line">{course.hora_1_detalle}</p>
                </div>

                {course.fecha_2_tipo && (
                  <div>
                    <p className="curso-info-titulo-naranja">{course.fecha_2_tipo}</p>
                    <p className="txt-landing txt-pre-line">
                      {course.fecha_2_detalle ? course.fecha_2_detalle.replace(/\.\s+/g, '.\n') : ''}
                    </p>
                  </div>
                )}
              </div>

              <div className="curso-zona-info-der">
                <div className="curso-info-margin-bottom-lg">
                  <p className="curso-info-titulo-verde">Gabriela Gutierrez</p>
                  <p className="txt-landing">📧 gabrielagutierrezcarrera@gmail.com</p>
                  <p className="txt-landing">📞 996 222 662</p>
                </div>
                <div>
                  <p className="curso-info-titulo-verde">Martin Olea</p>
                  <p className="txt-landing">📧 martinolea@onelearning.pe</p>
                  <p className="txt-landing">📞 51 958 966 927</p>
                </div>
              </div>
            </div>
          </div>

          {renderBotonCompra('centro')}
        </div>
      </section>

      <ContactForm />

      <CartModal
        isOpen={modalData.isOpen}
        courseImage={modalData.courseImage}
        subtotal={modalData.subtotal}
        type={modalData.type}
        onClose={closeModal}
        onGoToCart={() => {
          closeModal();
          setIsCartOpen(true);
        }}
      />
      
      <NotificationModal
        isOpen={isAuthWarningOpen}
        onClose={closeAuthWarning}
        title="INICIA SESIÓN PARA ADQUIRIR CURSOS"
        buttonText="Iniciar Sesión"
        onAction={() => {
          closeAuthWarning(); 
          openLoginModal();   
        }}
      />
    </>
  );
}

export default CursoLanding;